import { t } from 'ember-intl';
import { HdsPageHeader } from '@hashicorp/design-system-components/components';
import { CoreLayoutMain, BreadcrumbsContainer } from 'core/components';
import { v2ResourceDisplayName } from 'core/helpers';
import UpdateListTable from 'hcp/components/iam/groups/members/update-list-table';

const Edit = <template>
  <CoreLayoutMain>
    <:header>
      <HdsPageHeader as |P|>
        <P.Title>{{t
            "components.page.access-control.groups.detail.members.edit-members.title"
          }}</P.Title>
        <P.Breadcrumb>
          <BreadcrumbsContainer />
        </P.Breadcrumb>
        <P.IconTile @icon="users" @iconSecondary="plus" />
        <P.Subtitle>
          {{v2ResourceDisplayName @resourceName}}
        </P.Subtitle>
        <P.Description>
          {{t
            "components.page.access-control.groups.detail.members.edit-members.description"
          }}
        </P.Description>
      </HdsPageHeader>
    </:header>
    <:body>
      <UpdateListTable
        @submitBtnText={{t "components.iam.groups.form.edit-group-members.cta"}}
        @resourceName={{@resourceName}}
        @eligibleMembers={{@eligibleMembers}}
        @mode="edit"
      />
    </:body>
  </CoreLayoutMain>
</template>;

export default Edit;
